import { render, staticRenderFns } from "./ElectronicaNavar.vue?vue&type=template&id=0511a8d4&scoped=true"
import script from "./ElectronicaNavar.vue?vue&type=script&lang=js"
export * from "./ElectronicaNavar.vue?vue&type=script&lang=js"
import style0 from "./ElectronicaNavar.vue?vue&type=style&index=0&id=0511a8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511a8d4",
  null
  
)

export default component.exports